







































































import { Component, Vue, Prop } from 'vue-property-decorator';
import style from '@/my-theme/var.less'
@Component
export default class Result extends Vue {
  @Prop() private type: string;
  @Prop() private amount: any;
  @Prop() private taxDetail: object;
  private resultList = {
    success: {
      icon: 'ios-checkmark-circle-outline',
      color: style.primary,
      title: '操作成功',
    },
    error: {
      icon: 'ios-close-circle-outline',
      color: 'red',
      title: '操作失败',
    },
  };
  private handlerLogs() {
    this.$router.push({ name: 'income' });
  }
}
